<template>
  <div class="ncl">
    <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :disabled="ableFlag"> -->
      <!-- <detail-header v-show="chaerShow" v-if="headType !== 'D0104-1031'" :head-type="headType"></detail-header> -->
      <!-- <detail-headers></detail-headers> -->
      <operate-detail-header v-show="chaerShow"></operate-detail-header>
      <detail-card @postDate="getDate" @year="getYear" v-show="chaerShow"></detail-card>
      <detail-table :dateData="dateData" :year="year" @chaerShowClick="chaerShowClick"></detail-table>
      <!-- <smartbi-bank-pie :chooseDateValue="chooseDateValue" v-show="chaerShow"></smartbi-bank-pie> -->
      <!--    <detail-product v-if="structureShow!=1"></detail-product>-->
      <!--    <detail-structure v-if="structureShow!=1"></detail-structure>-->
      <!--    <detail-channel v-if="channelShow===2 && structureShow!=1"></detail-channel>-->
    <!-- </van-pull-refresh> -->
  </div>
</template>

<script>
import DetailHeaders from './components/Header'
import DetailHeader from './components/DetailHeader'
import DetailCard from './components/DetailCard'
import DetailTable from './components/OperateTable'
import OperateDetailHeader from './components/OperateDetailHeader'
// import { popData, popData_iOS, popDataShare_iOS, popDataIsCare_iOS } from '@/utils/util'
import { getUrlKey, resetUserSessionStorage } from '@/utils/util'

export default {
  name: 'Operate',
  components: {
    DetailHeader,
    DetailCard,
    DetailTable,
    DetailHeaders,
    OperateDetailHeader
  },
  data () {
    return {
      isLoading: false,
      headType: 1,
      channelShow: null,
      structureShow: null,
      dateData: null,
      chooseDateValue: null,
      unitR: null,
      structureType: null,
      chaerShow: true,
      ableFlag: false,
      year: null
    }
  },
  methods: {
    getDate (data1, data2) {
      this.dateData = data1
      data2 = data1
      this.chooseDateValue = data2
      // this.chooseDateValue = data1 || data2
    },
    getYear (val) {
      this.year = val
    },
    getStructureMsg (data1, data2) {
      this.structureType = data1
      this.unitR = data2
    },
    chaerShowClick (str) {
      this.chaerShow = str
    },
    // 控制下拉刷新
    getFlag (data) {
      this.ableFlag = data
    }
    // 关闭即取消详情页下拉刷新功能
    // onRefresh () {
    //   setTimeout(() => {
    //     this.$toast('刷新成功')
    //     this.isLoading = false
    //   }, 500)
    // }
  },
  computed: {
    getChannel () {
      return this.$store.state.ope.channel
    },
    getTime () {
      return this.$store.state.ope.time
    }
  },
  watch: {
    getChannel () {
      this.$nextTick(() => {
        this.channelShow = this.$store.state.ope.channel
      })
    },
    getTime () {
      this.$nextTick(() => {
        this.structureShow = this.$store.state.ope.time
      })
    }
  },
  created () {
    this.$store.commit('OPE_SET_QUOTA', this.$route.query.indexId)
    this.$store.commit('USER_SET_PAGE_CODE', this.$route.query.moduleId)
    this.$store.commit('OPE_SET_TIME', this.$route.query.time)
    this.$store.commit('OPE_SET_KIND', this.$route.query.kind)
    this.$store.commit('USER_SET_LEVEL', this.$route.query.level)
    this.$store.commit('USER_SET_ORG', this.$route.query.orgId)
  },
  mounted () {
    // 接收从首页路由跳转详情页传入参数,将传入的indexId赋值给变量headerType，绑定在组件中，判断机构id显示还是隐藏详情头部
    // this.headType = this.$route.query.indexId
    window.onpageshow = function (event) {
      if (event.persisted) {
        console.log('浏览器缓存读取-运营类')
        // 处理登录用户信息
        // let queryToken = getUrlKey('token', window.location.href)
        // resetUserSessionStorage(queryToken)
        let queryTm = getUrlKey('tm', window.location.href)
        resetUserSessionStorage(queryTm)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
 .ncl {
   overflow: hidden
 }
</style>



// WEBPACK FOOTER //
// src/pages/operate/OperateDetail.vue